import { InstituteService } from "@/services";

const getDefaultState = () => {
  return {
    items: null,
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getInstituteList(state) {
      return state.items;
    },
  },
  mutations: {
    SET_INSTITUTE_LIST(state, payload) {
      state.items = payload;
    },
    SET_DEFAULT_STATE(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async fetchInstituteList({ commit, getters }) {
      if (getters.getInstituteList == null) {
        const data = await InstituteService.getAll();
        let payload = data.map((el) => {
          return { value: el.id, text: el.instituteName };
        });
        commit("SET_INSTITUTE_LIST", payload);
      }
      return getters.getInstituteList;
    },
    async fetch({ commit }) {
      const data = await InstituteService.getAll();
      const payload = data.map((el) => {
        return { value: el.id, text: el.instituteName };
      });
      commit("SET_INSTITUTE_LIST", payload);
    },
    setDefaultState({ commit }) {
      commit("SET_DEFAULT_STATE");
    },
  },
};
